import { JADEDocumentationBrowserClient } from "./JADEDocumentationBrowserClient";

export function init(session: ConstructorParameters<typeof JADEDocumentationBrowserClient>[0], options: ConstructorParameters<typeof JADEDocumentationBrowserClient>[1], googleCloudStorageBasePublicUrl: ConstructorParameters<typeof JADEDocumentationBrowserClient>[2]): JADEDocumentationBrowserClient|void {
    try {
        return new JADEDocumentationBrowserClient(session, options, googleCloudStorageBasePublicUrl);
    } catch (error) {
        console.error(error);
    }
}